export function sendAnalyticsEvent(event, data = {}) {
  if (!event || typeof event !== 'string' || typeof data !== 'object') {
    throw new TypeError('You must pass an event [string] and data [object]');
  }

  if (window.dataLayer) {
    window.dataLayer.push({ event, ...data });
  } else {
    console.error('The dataLayer is not available', { event, ...data });
  }
}
